module.exports = "<app-menu-toggle></app-menu-toggle>\n<app-menu></app-menu>\n<router-outlet></router-outlet>\n"